import { CSSProperties, FC } from 'react';
import ContentLoader from 'react-content-loader';
import styles from './index.module.scss';

const CardLoading: FC<{ style?: CSSProperties; testId?: string }> = ({
  testId = 'card',
  style = {},
}) => (
  <div style={{ ...style }} className={styles.loading} data-test-id={`${testId}-loading`}>
    <ContentLoader
      speed={2}
      primaryColor="#f7f7f7"
      secondaryColor="#ecebeb"
      style={{ display: 'block' }}
    >
      <rect x="10" y="10" rx="25" ry="25" width="50" height="50" />
      <rect x="80" y="17" rx="4" ry="4" width="230" height="16" />
      <rect x="80" y="40" rx="3" ry="3" width="180" height="10" />
      <rect x="340" y="15" rx="1" ry="1" width="55" height="45" />
      <rect x="0" y="80" rx="1" ry="1" width="400" height="1" />
      <rect x="10" y="90" rx="3" ry="3" width="380" height="16" />
      <rect x="10" y="115" rx="3" ry="3" width="380" height="16" />
      <rect x="10" y="140" rx="3" ry="3" width="380" height="16" />
    </ContentLoader>
  </div>
);

export default CardLoading;
